import React from "react";

const AdminDashboardCard = ({
  label,
  icon,
  figure,
  description,
  complete,
  incomplete,
}) => {
  // Format the figure if it's a number (add commas for thousands)
  const formattedFigure =
    typeof figure === "number" ? figure.toLocaleString() : figure;

  return (
    <div className="p-6 bg-white shadow-lg rounded-xl flex flex-col gap-4 transition-all duration-300 hover:shadow-xl border border-gray-100">
      <div className="flex justify-between items-center">
        <span className="text-gray-500 font-semibold text-sm uppercase tracking-wider">
          {label}
        </span>
        <div className="text-gray-700 bg-gray-50 p-2 rounded-full">{icon}</div>
      </div>

      <div className="mt-1">
        <h3 className="text-gray-900 font-bold text-3xl">{formattedFigure}</h3>

        {description !== undefined && (
          <div className="flex items-center mt-2">
            <span className="inline-block bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-md px-2 py-1 text-xs font-medium">
              {description}%
            </span>
            <span className="text-gray-500 text-xs ml-2">of users</span>
          </div>
        )}
      </div>

      {(complete !== undefined || incomplete !== undefined) && (
        <div className="mt-2">
          {complete !== undefined && (
            <div className="flex justify-between items-center mb-1">
              <span className="text-gray-600 text-xs">Complete</span>
              <span className="text-gray-800 text-xs font-medium">
                {complete}
              </span>
            </div>
          )}

          {incomplete !== undefined && (
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-xs">Incomplete</span>
              <span className="text-gray-800 text-xs font-medium">
                {incomplete}
              </span>
            </div>
          )}

          {complete !== undefined && incomplete !== undefined && (
            <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5">
              <div
                className="bg-indigo-600 h-1.5 rounded-full"
                style={{
                  width: `${
                    (parseInt(complete) /
                      (parseInt(complete) + parseInt(incomplete))) *
                    100
                  }%`,
                }}
              ></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminDashboardCard;
